export default {
  data() {
    return {
      defaultRouteForRole: {
        user: "PropertyList",
        superadmin: "PropertyList",
        admin: "AdminUserList"
      }
    }
  },

  created() {
    if (localStorage.AuthToken) {
      this.redirectToDefaultPage()
    }
  },

  methods: {
    redirectToDefaultPage() {
      const role = localStorage.userRole
      this.$router.push({ name: this.defaultRouteForRole[role] })
    }
  }
}
